import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import Card from 'src/common/refactoredComponents/card/Card';
//import BasicCard from 'src/common/components/card/basicCard/BasicCard';
import {
    UsagePricingCardContainer,
    UsagePricingContainer,
    UsagePricingDataContainer,
    UsagePriceFont,
} from './UsagePricing.styled';
import { setCurrencyFormat, setItemsDataHandler } from 'src/utils/util';
import BundleCards from 'src/common/components/orderDetails/bundleCards';

import BillingSummaryDataTable from 'src/common/components/orderDetails/detailsDataTable/billingSummaryDataTable/BillingSummaryDataTable';
import { sizes } from 'src/styles/Media.styled';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const UsagePricing = ({ isUsagePricing, toggleCard, handleSetItemClick }) => {
    const [orderType, setOrderType] = useState();
    const { t } = useTranslation();

    const winWidth = window.innerWidth;

    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );

    useEffectWithErrorLogging(() => {
        setOrderType(orderBasicDetails?.currentOrderType);
    }, []);

    const usagePrice = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.usagePricing
    );
    const isFromOrderHistory = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.isFromOrderHistory
    );
    const [usagePricing, setUsagePricing] = useState([]);
    const [expandRow, setExpandRow] = useState(null);

    const usagePricingCartSummary = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.cartSummary
    );

    const currencyISOCode = useSelector(
        (state) =>
            state.orderSummaryReducer.billingSummary?.cartSummary
                ?.currencyISOCode
    );

    let { poDetails, cartItems, total, pricingNotes } =
        usagePricingCartSummary || {};

    const isOrderHistorySummaryFallback =
        isFromOrderHistory &&
        !usagePricingCartSummary &&
        usagePrice?.length > 0;

    if (isOrderHistorySummaryFallback) {
        poDetails = [
            ...new Set(
                usagePrice.map((item) => item?.poNumber).filter(Boolean)
            ),
        ].map((poNumber) => ({ poNumber }));
        cartItems = usagePrice.reduce(
            (sum, item) => sum + (Number(item?.quantity) || 0),
            0
        );
        total = null;
    }

    useEffectWithErrorLogging(() => {
        if (usagePrice) {
            setUsagePricing(
                usagePrice?.map((d, i) => {
                    return { ...d, key: '' + i };
                })
            );
        }
    }, [usagePrice]);

    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };

    const mobileSubItemsColumns = [
        {
            field: 'subItemsDescription',
            header: t('orders.shipTrackLabels.productItemDescriptionLabel'),
            width: '75%',
        },
        {
            field: 'quantity',
            header: t('orders.shipTrackLabels.mobileProductQtyLabel'),
            width: '20%',
        },
    ];

    const updateRowExpandHandler = (expandRow) => {
        setExpandRow(expandRow);
    };

    const checkBundle =
        usagePrice?.filter((x) => x.isBundleHeader)?.length > 0 ? true : false;

    const usagePricingCount = usagePricing.length;

    return (
        <>
            <CollapsableCard
                id="orders-usagePricing-usagePricing-usagePricing"
                title={
                    orderType === 'KE'
                        ? isFromOrderHistory
                            ? t('orders.shipTrackLabels.usage')
                            : winWidth <= sizes.mobileDevice
                            ? t('orders.shipTrackLabels.billingprice') +
                              '(' +
                              usagePricingCount +
                              ')'
                            : t('orders.shipTrackLabels.billingprice')
                        : isFromOrderHistory
                        ? t('orders.shipTrackLabels.usage')
                        : t('orders.shipTrackLabels.usageprice')
                }
                titleFontSize={'15px'}
                onClick={() => toggleCard('isUsagePricing', !isUsagePricing)}
                isExpanded={isUsagePricing}
                padding={'0.8rem'}
                cursor={'pointer'}
                mbHeaderMargin={
                    orderType === 'KE' && isUsagePricing ? '0 0 5px 0' : ''
                }
            >
                {isUsagePricing && usagePricing ? (
                    <>
                        <BillingSummaryDataTable
                            isUsagePricing={isUsagePricing}
                            data={usagePricing}
                            isBundleTable={checkBundle}
                            keyValue={'key'}
                            bundleSubGroup={'bundleItems'}
                            rowExpand={expandRow}
                            setItemHandler={setItemHandler}
                            updateRowExpandHandler={updateRowExpandHandler}
                            orderType={orderType}
                            isBundle = {true}
                            itemDescWidth={orderType === 'KE' ? '30%' : null}
                            unitPriceWidth={orderType === 'KE' ? '20%' : null}
                            qtyPriceWidth={orderType === 'KE' ? '20%' : null}
                            lotSerialWidth={orderType === 'KE' ? '15.5%' : null}
                        />
                        {isUsagePricing && usagePricing ? (
                            <>
                                {usagePricing?.length > 0 ? (
                                    <>
                                        {usagePricing.map(
                                            (usagePrice, index) => {
                                                const isBundle =
                                                    usagePrice?.isBundleHeader
                                                        ? usagePrice.isBundleHeader
                                                        : false;
                                                return (
                                                    <UsagePricingCardContainer
                                                        key={
                                                            index +
                                                            usagePrice.cfn
                                                        }
                                                    >
                                                        <BundleCards
                                                            keyIndex={
                                                                usagePrice.cfn
                                                            }
                                                            isBundle={isBundle}
                                                            setItemHandler={
                                                                setItemHandler
                                                            }
                                                            setDetailsData={
                                                                usagePrice
                                                            }
                                                            cfn={usagePrice.cfn}
                                                            quantity={
                                                                usagePrice.quantity
                                                            }
                                                            serialNo={
                                                                usagePrice.serialNo
                                                            }
                                                            description={
                                                                usagePrice.description
                                                            }
                                                            poNumber={
                                                                usagePrice.poNumber
                                                            }
                                                            unitPrice={
                                                                usagePrice.unitPrice
                                                            }
                                                            subUnitPrice={
                                                                usagePrice.overridenUnitPrice
                                                            }
                                                            extPrice={
                                                                usagePrice.extPrice
                                                            }
                                                            subExtPrice={
                                                                usagePrice.overridenExtPrice
                                                            }
                                                            subItemsData={
                                                                isBundle &&
                                                                usagePrice
                                                                    ?.bundleItems
                                                                    ?.length > 0
                                                                    ? usagePrice.bundleItems
                                                                    : []
                                                            }
                                                            subItemsColumns={
                                                                isBundle
                                                                    ? mobileSubItemsColumns
                                                                    : []
                                                            }
                                                            descriptionMobileFontSize={
                                                                '13px'
                                                            }
                                                            isUsed={
                                                                usagePrice.isUsed
                                                            }
                                                            isAccountOwned={
                                                                usagePrice.isAccountOwned
                                                            }
                                                            orderType={
                                                                orderType
                                                            }
                                                            isDiscount={true}
                                                            isAttachment={
                                                                orderType ===
                                                                'KE'
                                                                    ? usagePrice.attachmentList
                                                                    : null
                                                            }
                                                            hidePricing={
                                                                isFromOrderHistory
                                                            }
                                                        />
                                                    </UsagePricingCardContainer>
                                                );
                                            }
                                        )}
                                    </>
                                ) : null}
                            </>
                        ) : null}
                        {usagePricingCartSummary ||
                        isOrderHistorySummaryFallback ? (
                            <Card
                                padding={
                                    orderType === 'KE'
                                        ? '15px 10px 10px 10px'
                                        : '10px'
                                }
                                margin={'10px 0 0 0'}
                            >
                                <UsagePricingContainer>
                                    <UsagePriceFont
                                    isBundle = {true}
                                        color="#140F4B"
                                        fontFamily="AvenirNextWorld Demi"
                                        margin={
                                            orderType === 'KE'
                                                ? '0 0 18px 0'
                                                : '0 0 10px 0'
                                        }
                                        fontSize="15px"
                                        letterSpacing="-0.12px"
                                    >
                                        {t('reportUsage.summary.title')}
                                    </UsagePriceFont>
                                    {/* {item?.payment?.poAttachment ? (
                                        item.payment.poAttachment
                                            ?.split(',')
                                            .map((ele) => (
                                        <PoInfoView
                                            key={ele}
                                            fileName={ele}
                                            item={item}
                                        />
                                    ))
                                    ) : (
                                    <PoInfoView item={item} />
                                    )} */}
                                    {poDetails && poDetails?.length > 0 ? (
                                        <>
                                            {poDetails?.map(
                                                (poDetail, index) => {
                                                    return (
                                                        <UsagePricingDataContainer
                                                            key={index}
                                                            margin={'0 0 5px 0'}
                                                            justifyContent="space-between"
                                                        >
                                                            <UsagePriceFont
                                                                color="#4F4F4F"
                                                                fontSize="15px"
                                                                letterSpacing="-0.12px"
                                                                lineHeight="23px"
                                                            >{`PO: ${
                                                                poDetail?.poNumber
                                                                    ? poDetail.poNumber
                                                                    : ''
                                                            }`}</UsagePriceFont>
                                                            {poDetail?.price !=
                                                            null ? (
                                                                <UsagePriceFont
                                                                    color="#4F4F4F"
                                                                    fontSize="15px"
                                                                    letterSpacing="-0.12px"
                                                                    lineHeight="23px"
                                                                >
                                                                    {setCurrencyFormat(
                                                                        poDetail?.price,
                                                                        true,
                                                                        {
                                                                            currency:
                                                                                currencyISOCode,
                                                                        }
                                                                    )}
                                                                </UsagePriceFont>
                                                            ) : null}
                                                        </UsagePricingDataContainer>
                                                    );
                                                }
                                            )}
                                        </>
                                    ) : null}
                                    {cartItems ? (
                                        <UsagePricingDataContainer
                                            margin={'0 0 5px 0'}
                                            justifyContent="space-between"
                                        >
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {t(
                                                    'orders.shipTrackLabels.cartitems'
                                                )}
                                            </UsagePriceFont>
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="15px"
                                                letterSpacing="-0.12px"
                                                lineHeight="23px"
                                            >
                                                {cartItems ? +cartItems : 0}
                                            </UsagePriceFont>
                                        </UsagePricingDataContainer>
                                    ) : null}
                                    {(total !== undefined &&
                                        total !== null) ||
                                    isOrderHistorySummaryFallback ? (
                                        <UsagePricingDataContainer
                                            margin={'0 0 5px 0'}
                                            justifyContent="space-between"
                                        >
                                            <UsagePriceFont
                                                color="#4F4F4F"
                                                fontSize="16px"
                                                letterSpacing="-0.13px"
                                                lineHeight="23px"
                                                fontFamily="AvenirNextWorld Demi"
                                            >
                                                {t(
                                                    'orders.orderDetails.priceOverride.priceOverrideSummary.total'
                                                )}
                                            </UsagePriceFont>
                                            {!isOrderHistorySummaryFallback ? (
                                                <UsagePriceFont
                                                    color="#4F4F4F"
                                                    fontSize="16px"
                                                    letterSpacing="-0.13px"
                                                    lineHeight="23px"
                                                    fontFamily="AvenirNextWorld Demi"
                                                >
                                                    {total
                                                        ? setCurrencyFormat(
                                                              total,
                                                              true,
                                                              {
                                                                  currency:
                                                                      currencyISOCode,
                                                              }
                                                          )
                                                        : setCurrencyFormat(
                                                              0,
                                                              true,
                                                              {
                                                                  currency:
                                                                      currencyISOCode,
                                                              }
                                                          )}
                                                </UsagePriceFont>
                                            ) : null}
                                        </UsagePricingDataContainer>
                                    ) : null}
                                </UsagePricingContainer>
                            </Card>
                        ) : null}
                        {pricingNotes && pricingNotes?.length > 0 ? (
                            <Card padding={'10px'} margin={'10px 0 0 0'}>
                                <UsagePricingContainer>
                                    <UsagePriceFont
                                        color="#140F4B"
                                        fontFamily="AvenirNextWorld Demi"
                                        margin={'0 0 10px 0'}
                                        fontSize="15px"
                                        letterSpacing="-0.12px"
                                    >
                                        {t(
                                            'orders.orderDetails.billingSummary.shippedItems.pricingNotes'
                                        )}
                                    </UsagePriceFont>

                                    <>
                                        {pricingNotes.map((notes) => {
                                            return (
                                                <UsagePricingDataContainer
                                                    key={notes.time}
                                                    margin={'0 0 2px 0'}
                                                >
                                                    <UsagePriceFont
                                                        color="#202124"
                                                        fontSize="15px"
                                                        lineHeight="18px"
                                                    >
                                                        {/* {`${index + 1}. ${
                                                            notes.comments
                                                        }`} */}
                                                        {notes.comments}
                                                    </UsagePriceFont>
                                                </UsagePricingDataContainer>
                                            );
                                        })}
                                    </>
                                </UsagePricingContainer>
                            </Card>
                        ) : null}
                    </>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default UsagePricing;
